// extracted by mini-css-extract-plugin
export default {"highlight":"TextHighlighter_highlight__GeHKw"};